<!-- Chat Sidebar area -->
<div class="chat-sidebar bg-white">
  <button class="btn sidebar-close-icon" (click)="toggleSidebar('chat-sidebar')">
    <i data-feather="x"></i>
  </button>
  <!-- Sidebar header start -->
  <div class="chat-fixed-search">
    <div class="d-flex align-items-center w-100">
      <div class="sidebar-profile-toggle">
        <button class="btn avatar avatar-border bg-transparent p-0" (click)="toggleSidebar('chat-user-sidebar')">
          <img [alt]="userProfile.complete_name" [src]="userProfile.avatar" height="42" width="42" />
          <span class="avatar-status-{{userProfile.status}}"></span>
        </button>
      </div>
      <div class="input-group input-group-merge ml-1 w-100">
        <div class="input-group-prepend">
          <span class="input-group-text round"><i data-feather="search" class="text-muted"></i></span>
        </div>
        <input type="text" class="form-control round" id="chat-search" [placeholder]="'SEARCH_CHAT' | translate" aria-label="Search..." aria-describedby="chat-search" [(ngModel)]="searchText" />
      </div>
    </div>
  </div>
  <!-- Sidebar header end -->

  <!-- Sidebar Users start -->
  <div id="users-list" class="chat-user-list-wrapper list-group">
    <h4 class="chat-list-title">{{ "CHAT" | translate }}</h4>
    <ng-container *ngIf="(chatUsers | filter: searchText : 'complete_name').length; else noResultsChats"></ng-container>
    <ul class="chat-users-list chat-list media-list">
      <li
        *ngFor="let chatUser of chatUsers | filter: searchText : 'complete_name'"
        [class.active]="selectedHash === chatUser.hash"
        (click)="openChat(chatUser.hash); toggleSidebar('chat-sidebar'); setSelectedChat(chatUser.hash, false)"
      >
        <span class="avatar"
        ><img class="round" alt="avatar" [src]="chatUser.avatar" height="42" width="42" />
          <span
            [ngClass]="{
              'avatar-status-offline': chatUser.status == 'offline',
              'avatar-status-online': chatUser.status == 'online',
              'avatar-status-busy': chatUser.status == 'busy',
              'avatar-status-away': chatUser.status == 'away'
            }"
          ></span>
        </span>
        <div class="chat-info flex-grow-1">
          <h5 class="mb-0">{{ chatUser.complete_name }}</h5>
          <p class="card-text text-truncate">
            {{ chatUser?.last_message?.message }}
          </p>
        </div>
        <div class="chat-meta d-flex flex-column justify-content-center">
          <small class="float-right mb-25 chat-time">{{ chatUser?.last_message?.create_date | date: "H:mm" }}</small>
          <span *ngIf="chatUser.unread_messages >= 1" class="float-right badge badge-primary badge-pill">{{ chatUser.unread_messages }}</span>
        </div>
      </li>

      <ng-template #noResultsChats>
        <li class="no-results" [ngClass]="{ show: (chatUsers | filter: searchText : 'complete_name').length <= 0 }">
          <h6 class="mb-0">{{ "NO_FOUND_CHAT" | translate }}</h6>
        </li>
      </ng-template>
    </ul>
    <h4 class="chat-list-title">{{ "CONTACTS" | translate }}</h4>
    <ng-container *ngIf="(contacts | filter: searchText : 'complete_name').length; else noResultsContacts"></ng-container>
    <ul class="chat-users-list contact-list media-list">
      <li *ngFor="let contact of contacts | filter: searchText : 'complete_name'" (click)="openChat(contact.hash); toggleSidebar('chat-sidebar'); setSelectedChat(contact.hash, true)">
        <span class="avatar">
          <img class="round" [alt]="contact.complete_name" [src]="contact.avatar" height="42" width="42" />
          <span class="avatar-status-{{ contact.status }}"></span>
        </span>
        <div class="chat-info">
          <h5 class="mb-0">{{ contact.complete_name }}</h5>
          <p class="card-text text-truncate">{{ contact.figure }}</p>
        </div>
      </li>

      <ng-template #noResultsContacts>
        <li class="no-results" [ngClass]="{ show: (contacts | filter: searchText : 'complete_name').length <= 0 }">
          <h6 class="mb-0">{{ "NO_FOUND_CONTACTS" | translate }}</h6>
        </li>
      </ng-template>
    </ul>
  </div>
  <!-- Sidebar Users end -->
</div>
<!--/ Chat Sidebar area -->
